import { RouteItem } from '@host/components/nav-section/types'
import { matchPath, useLocation } from 'react-router-dom'

// ----------------------------------------------------------------------

type ReturnType = {
  active: boolean
  isExternalLink: boolean
}
export function useActiveNavItem(routeItem: RouteItem): ReturnType {
  const { pathname } = useLocation()

  const isActive = (item: RouteItem): boolean => {
    if (!item.path) return false

    const normalize = (p: string) => {
      while (p.endsWith('/')) {
        p = p.slice(0, -1)
      }
      return p
    }
    const current = normalize(pathname)
    const target = normalize(item.path)

    if (
      matchPath({ path: target, end: false }, current) ||
      matchPath({ path: target, end: true }, current)
    ) {
      return true
    }

    if (item.children) {
      return item.children.some(child => isActive(child))
    }
    return false
  }

  return {
    active: isActive(routeItem),
    isExternalLink: !!routeItem.path && routeItem.path.startsWith('http'),
  }
}
